import { render } from "./PayrollInsightsChart.vue?vue&type=template&id=a971bf90"
import script from "./PayrollInsightsChart.vue?vue&type=script&lang=js"
export * from "./PayrollInsightsChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__